import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { Link } from 'react-router';
import LargeCard from '../main/large-card';
import LeftSide from '../main/left-side';
import RightSide from '../main/right-side';
import TitleCard from '../main/title-card';
import useTranslate from '../useTranslate';
import VipSelectLocationCard from './vip-select-location-card';
import Navbar from '../navigation/navbar';

function VipSelectLaundryRoomWrapper() {
    const strings = useTranslate('VipSelectLocationCard');

    return (
        <Navbar nav>
            <Row>
                <LeftSide>
                    <TitleCard
                        title={strings.title}
                        left={{
                            content: (
                                <Link
                                    to={'/dashboard'}
                                    className="icon icon-wew-arrow-left icon-sm"
                                />
                            ),
                            title: strings.back,
                        }}
                    />
                </LeftSide>
                <Col xs={6} className={'col-middle'}>
                    <Row>
                        <LargeCard type="card-edit" title={strings.title}>
                            {strings.explanation}
                            <VipSelectLocationCard />
                        </LargeCard>
                    </Row>
                </Col>
                <RightSide />
            </Row>
        </Navbar>
    );
}

export default VipSelectLaundryRoomWrapper;
